export const huHU = {
  app: {
    categories: {
      convectors: 'Konvektorok',
      decorative: 'Dekoratív',
      electric: 'Elektromos',
      panels: 'Panelok',
      towel: 'Törölközőszárítók',
    },
    categoryLabel: 'Kategória',
    categoryPlaceholder: 'Válasszon kategóriát',
    errorCategories: 'A kategóriák betöltése sikertelen.',
    errorPanels: 'A radiátorok betöltése sikertelen.',
    loadingCategories: 'Kategóriák betöltése...',
    loadingPanels: 'Radiátorok betöltése...',
    panelLabel: 'Radiátorok',
    panelPlaceholder: 'Válasszon radátort',
    titles: {
      convectors: 'Konvektor kalkulátor',
      decorative: 'Dizájn radiátor kalkulátor',
      electric: 'Elektromos radiátor kalkulátor',
      panels: 'Panel radiátor kalkulátor',
      towel: 'Törölközőszárító kalkulátor',
    },
  },
  calc: {
    actionButton: 'Kiszámított termékek megjelenítése',
    boost: 'Turbó üzemmód',
    calculateRequiredButton: 'Szükséges teljesítmény kiszámítása',
    calculating: 'Számítás...',
    comfort: 'Komfort üzemmód',
    downloadLabel: 'Adatok letöltése ({count})',
    emptyResults: 'Még nincs eredmény.',
    errorMatch: 'Az eredmények kiszámítása sikertelen.',
    errorTypes: 'A radiátortípusok betöltése sikertelen.',
    flowTemp: 'Előremenő hőmérséklet C°',
    height: 'Magasság',
    length: 'Hossz',
    loadingTypes: 'Típusok betöltése...',
    modeLabel: 'Üzemmód',
    modes: {
      cooling: 'Hűtés',
      heating: 'Fűtés',
    },
    radiatorType: 'Radiátor típusa',
    requiredWatts: 'Szükséges teljesítmény',
    resultsMessage: '{count} termék érhető el a kiválasztott beállításokhoz.',
    returnTemp: 'Visszatérő hőmérséklet C°',
    roomTemp: 'Szoba hőmérséklete C°',
    selectAllLabel: 'Összes termék kijelölése',
    selectItemLabel: 'Válasszon terméket a letöltéshez',
    selectPanel: 'Válasszon radátort a számításhoz.',
    standby: 'Készenléti üzemmód',
    tableHeaders: {
      calculatedWattage: 'Watt',
      co2Equivalent: 'CO2 egyenérték kg anyagonként',
      depth: 'Mélység [mm]',
      description: 'Termékleírás',
      dop: 'DOP',
      eudop: 'EU DOP',
      height: 'Magasság [mm]',
      itemId: 'Cikkszám',
      length: 'Hossz [mm]',
      waterContent: 'Víztartalom',
      weight: 'Súly',
    },
    title: 'Számítások',
    tolerance: 'Tolerancia',
    typeCooling: 'Hűtés',
    typeGroupLabel: 'Típus',
    typeHeating: 'Fűtés',
  },
  existingRadiator: {
    description:
      'Ez a kalkulátor kizárólag tájékoztatási célokat szolgál. Radiátor vásárlása előtt mindig forduljon szakemberhez a pontos számításért.',
    height: 'Radiátor magassága',
    length: 'Radiátor hossza',
    resultLabelTemplate: 'Hőteljesítmény-szükséglet, számítva {temp} rendszerhőmérsékleten',
    select: 'Kiválasztás',
    temperature: 'Rendszer hőmérséklete',
    type: 'Radiátor típusa',
  },
  matrixCalc: {
    axisHeight: 'Magasság (mm)',
    axisLength: 'Hossz (mm)',
    axisType: 'Típus',
    calculateButton: 'Calculate',
    displayLabel: 'Megjelenítés',
    exportExcel: 'Exportálás Excelbe',
    exportPdf: 'Exportálás PDF-be',
    print: 'Nyomtatás',
    hideOutOfRange: 'Tartományon kívüli tételek elrejtése',
    showAll: 'Összes megjelenítése',
    loading: 'Loading...',
    lockHeight: 'Magasság',
    lockLabel: 'Méret rögzítése',
    lockLength: 'Hossz',
    lockType: 'Típus',
    noData: 'Select a radiator and click Calculate to view the matrix.',
    noItem: '—',
    noType: '—',
    targetOutput: 'Target output (W)',
    title: 'Matrix Calculator',
    tolerance: 'Tolerance (%)',
  },
  roomCalc: {
    actionButton: 'Számítás',
    clearButton: 'Törlés',
    fields: {
      ceilingHeight: 'Belmagasság',
      doorInsulation: 'Ajtók hőszigetelése',
      floorInsulation: 'Padló hőszigetelése',
      glazingArea: 'Üvegezett felület',
      glazingMode: 'Üvegezett felület',
      glazingQuality: 'Üvegezés minősége',
      length: 'Hossz',
      outerWalls: 'Külső falak',
      projectedDesignTemp: 'Tervezett külső hőmérséklet (TKH) az épület helyszínén',
      roofInsulation: 'Tető hőszigetelése',
      roomArea: 'Helyiség területe',
      roomFloor: 'Emelet',
      roomInsulation: 'Helyiség hőszigetelése',
      roomPreset: 'Helyiség típusa',
      roomTemperature: 'Helyiség hőmérséklete',
      roomType: 'Helyiség típusa',
      uncertaintyFactor: 'Biztonsági tényező',
      ventilation: 'Szellőzési szint',
      wallInsulation: 'Falak hőszigetelése',
      width: 'Szélesség',
      windConditions: 'Szélviszonyok',
      windowInsulation: 'Ablakok hőszigetelése',
    },
    intro:
      'Számítsa ki a helyiség hőveszteségét, hogy kiválaszthassa a megfelelő terméket a radiátoraink kínálatából.',
    options: {
      glazing: {
        m2: 'm²',
        percent: '%',
      },
      glazingBands: {
        high: 'Több mint 20%',
        low: 'Kevesebb mint 10%',
        mid: '10-20%',
      },
      glazingValue: {
        above_20: '20% felett',
        below_10: '10% alatt',
        from_10_to_20: '10%-tól 20%-ig',
        no_windows: 'Ablakok nélkül',
      },
      insulationValue: {
        good: 'Jó',
        medium: 'Közepes',
        poor: 'Gyenge',
        very_good: 'Nagyon jó',
      },
      qualityValue: {
        modern_excellent: 'Modern, kiváló energiahatékonyság',
        modern_good: 'Modern, jó energiahatékonyság',
        old_poor: 'Régi, nagyon gyenge energiahatékonyság',
        traditional_medium: 'Hagyományos, közepes energiahatékonyság',
      },
      roomValue: {
        bathroom_24: 'Fürdőszoba (24 C°)',
        bedroom_20: 'Hálószoba (20 C°)',
        garage_12: 'Garázs (12 C°)',
        livingroom_22: 'Nappali (22 C°)',
        storage_16: 'Tároló (16 C°)',
      },
      select: 'Kiválasztás',
      storeyValue: {
        ground_multi: 'Földszint (többemeletes)',
        ground_single: 'Földszint (egyemeletes)',
        interim: 'Középső emelet',
        top_multi: 'Legfelső emelet (többemeletes)',
      },
      temp: {
        climate_zone_1: 'Szárazföldek (-4C°)',
        climate_zone_2: 'Enyhe tengerpart (-1,5C°)',
        climate_zone_3: 'Északi (-4,5C°)',
        climate_zone_4: 'Skócia (-5,5C°)',
        climate_zone_5: 'Déli (-3,5C°)',
        climate_zone_6: 'Nagyon hideg vagy magaslati (-6,5C°)',
      },
      windInfluence: {
        normal: 'Normál',
        strong: 'Erős',
        weak: 'Enyhe',
      },
    },
    roomPresets: {
      bathroom: 'Fürdőszoba',
      bedroom: 'Hálószoba',
      garage: 'Garázs',
      kitchen: 'Konyha',
      living: 'Nappali',
      storage: 'Tároló',
    },
    sections: {
      dimensions: 'Helyiség méretei',
      insulation: 'Hőszigetelés',
      placement: 'Elhelyezés',
      result: 'Eredmény',
      temps: 'Hőmérsékletek',
      ventilation: 'Szellőzés',
    },
    title: 'Hőveszteség kalkulátor',
    units: {
      celsius: 'C°',
      meter: 'm',
      percent: '%',
      squareMeter: 'm²',
      watts: 'W',
    },
    useButton: 'Használat',
  },
  slider: {
    from: 'Tól',
    to: 'Ig',
    value: 'Érték',
  },
}
